// extracted by mini-css-extract-plugin
module.exports = {"holder":"Mission_holder__1i78H","content":"Mission_content__2gx6a","heading":"Mission_heading__3iR6V","para1":"Mission_para1__ddxMy","para2":"Mission_para2__3d8a7"};